import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DeezerLoginPromptService } from './deezer-login-prompt.service';
import { DeezerKind, deezerPageUrl, deezerWidgetUrl } from './deezer-links';

/** Deezer's embeddable player for a song or an album. Log in to Deezer inside it to hear full songs. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-deezer-embed',
  template: `
    @if (src(); as url) {
    <iframe class="deezer-embed" [src]="url" [style.height.px]="kind() === 'album' ? 300 : 92" title="Deezer player"
      allow="autoplay; clipboard-write; encrypted-media" loading="lazy"></iframe>
    <p class="embed-note">
      Log in to Deezer in the player above to hear full songs
      (<button type="button" class="embed-login" (click)="login.openDeezerLogin()">or log in in a new window</button>).
      <a [href]="pageUrl()" target="_blank" rel="noopener noreferrer">Having trouble? Open on Deezer</a>
    </p>
    }
  `,
  styles: [`
    :host { display: block; width: 100%; }
    .deezer-embed { width: 100%; border: 0; border-radius: 8px; }
    .embed-note { margin: 4px 0 0; font-size: 0.75rem; color: #666; }
    .embed-login { font: inherit; border: none; background: none; color: #673ab7; cursor: pointer; padding: 0; text-decoration: underline; }
  `]
})
export class DeezerEmbedComponent {
  private sanitizer = inject(DomSanitizer);
  protected login = inject(DeezerLoginPromptService);

  kind = input.required<DeezerKind>();
  id = input.required<string | number>();

  pageUrl = computed(() => deezerPageUrl(this.kind(), this.id()));
  src = computed<SafeResourceUrl | null>(() => {
    const url = deezerWidgetUrl(this.kind(), this.id());
    // The URL is built only from a fixed host and a numeric id, so trusting it is safe
    return url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
  });
}
